'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemScreenReaderDescription;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _formatIndicator = require('@bibliocommons/format-indicator');

var _formatIndicator2 = _interopRequireDefault(_formatIndicator);

var _baseByAuthorBlock = require('@bibliocommons/base-by-author-block');

var _baseByAuthorBlock2 = _interopRequireDefault(_baseByAuthorBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderBibDescription = function renderBibDescription(item) {
  var title = item.getIn(['bibListItem', 'title']);
  var format = item.getIn(['bibListItem', 'format']);
  var authors = item.getIn(['bibListItem', 'authors']);
  return _react2.default.createElement(
    'span',
    null,
    title + ' ',
    _react2.default.createElement(_baseByAuthorBlock2.default, {
      authors: authors,
      renderAsLink: false }),
    authors && format ? ', ' : null,
    format ? _react2.default.createElement(_formatIndicator2.default, { format: format.toUpperCase() }) : null
  );
};

var renderWebItemDescription = function renderWebItemDescription(item) {
  return item.getIn(['urlListItem', 'url', 'title']);
};

function ItemScreenReaderDescription(_ref) {
  var item = _ref.item;

  return _react2.default.createElement(
    'span',
    { className: 'cp-item-screen-reader-description' },
    item.get('bibListItem') ? renderBibDescription(item) : renderWebItemDescription(item)
  );
}

ItemScreenReaderDescription.propTypes = {
  item: _bcPropTypes.listItemShape
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-screen-reader-description/components/ItemScreenReaderDescription.component.js
// module id = 1304
// module chunks = 0